import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Country from 'modules/core/components/Inputs/Country'
import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import legalEntities from 'modules/core/store/collections/legalEntities'

import CurrencySelector from 'modules/settings/components/CurrencySelector'
import LegalEntityForm from 'modules/settings/lib/forms/LegalEntityForm'

type ModalProps = React.ComponentProps<typeof Modal>

interface Props {
  onClose: ModalProps['onClose']
  onSuccess: (id: string) => void
}

const CreateLegalEntity = ({ onClose, onSuccess }: Props) => {
  const form = useLazyRef(() => new LegalEntityForm({})).current

  const onSubmit = async (closePortal: ClosePortalFn) => {
    const { success, value } = await asyncAction(() => {
      return form.create(legalEntities)
    })
    closePortal({
      preventOnCloseCallbackAfterClose: success,
    })

    if (success) onSuccess(value.id)
  }

  const disabled =
    !form.get('legal_name').value || !form.get('country').value || !form.get('currency').value

  return (
    <Modal
      illustration="building"
      title={i18n.t('settings.legal_entities.legal_entity.create.title')}
      description={i18n.t('settings.legal_entities.legal_entity.create.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button disabled={disabled} submit>
          {i18n.t('settings.legal_entities.legal_entity.create.submit')}
        </Button>
      }
    >
      <FormRow>
        <Text label={i18n.t('common.legal_entity')} field={form.get('legal_name')} mandatory />
      </FormRow>
      <FormRow>
        <Country
          label={i18n.t('address_input.country')}
          field={form.get('country')}
          value="Spain"
        />
      </FormRow>
      <FormRow>
        <CurrencySelector field={form.get('currency')} />
      </FormRow>
    </Modal>
  )
}

export default observer(CreateLegalEntity)
